module.exports = __webpack_public_path__ + "media/images/logo-lg-9d2d61273fd117e67109be08e9a01e88.png";